/**
 * びとっくのタイプ選択：選択した商品ページへ遷移
 */
function initKitLinkSelect() {
  const selects = document.querySelectorAll('.c-kit-link__select');
  if (!selects.length) return;

  selects.forEach((select) => {
    select.addEventListener('change', () => {
      const url = select.value;
      if (!url) return;
      window.location.href = url;
    });
  });
}

/**
 * 標準キットセット：画像クリックでポップアップ表示
 */
function initKitBitookuModal() {
  const modal = document.getElementById('kit-bitooku-modal');
  const bitooku = document.querySelector('.p-kit-bitooku');
  if (!modal || !bitooku) return;

  const modalImg = modal.querySelector('.p-kit-bitooku-modal__img');
  const modalCaption = modal.querySelector('.p-kit-bitooku-modal__caption');
  const modalText = modal.querySelector('.p-kit-bitooku-modal__text');
  const closeTriggers = modal.querySelectorAll('[data-kit-bitooku-modal-close]');

  if (!modalImg || !modalCaption || !modalText) return;

  let lastFocused = null;

  const getCaptionText = (figcaption) => {
    if (!figcaption) return '';
    return figcaption.textContent.trim();
  };

  const openModal = (figure) => {
    const img = figure.querySelector('img');
    const caption = figure.querySelector('.p-kit-bitooku__caption');
    if (!img) return;

    lastFocused = figure;

    modalImg.src = img.currentSrc || img.src;
    modalImg.alt = img.alt || '';

    if (caption) {
      modalCaption.innerHTML = caption.innerHTML;
    } else {
      modalCaption.textContent = '';
    }

    const item = figure.closest('.p-kit-bitooku__item');
    const detail = item
      ? item.querySelector('.p-kit-bitooku__detail')
      : figure.querySelector('.p-kit-bitooku__detail');
    const detailText = detail ? detail.textContent.trim() : '';

    if (detailText) {
      modalText.textContent = detailText;
      modalText.hidden = false;
    } else {
      modalText.textContent = '';
      modalText.hidden = true;
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    const closeBtn = modal.querySelector('.p-kit-bitooku-modal__close');
    if (closeBtn) closeBtn.focus();
  };

  const closeModal = () => {
    modal.hidden = true;
    document.body.style.overflow = '';
    modalImg.removeAttribute('src');

    if (lastFocused) {
      lastFocused.focus();
    }
    lastFocused = null;
  };

  bitooku.addEventListener('click', (event) => {
    const figure = event.target.closest('.p-kit-bitooku__figure');
    if (!figure) return;
    openModal(figure);
  });

  bitooku.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const figure = event.target.closest('.p-kit-bitooku__figure');
    if (!figure) return;
    event.preventDefault();
    openModal(figure);
  });

  bitooku.querySelectorAll('.p-kit-bitooku__figure').forEach((figure) => {
    const caption = figure.querySelector('.p-kit-bitooku__caption');
    const img = figure.querySelector('img');
    const label = getCaptionText(caption) || (img && img.alt) || '項目';

    figure.setAttribute('tabindex', '0');
    figure.setAttribute('role', 'button');
    figure.setAttribute('aria-label', `${label}の詳細を表示`);
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}

const kitBitookuCarouselState = new WeakMap();

const KIT_BITOOKU_DRAG_THRESHOLD = 8;

/**
 * 標準キットセット：ドラッグ・フリックで横スクロール（タップはモーダル用に維持）
 */
function bindKitBitookuCarouselInteraction(carousel) {
  const viewport = carousel.querySelector('.p-kit-bitooku__viewport');
  if (!viewport || viewport.dataset.kitBitookuDragBound === 'true') return;

  viewport.dataset.kitBitookuDragBound = 'true';

  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;

  const pauseAutoScroll = () => {
    const state = kitBitookuCarouselState.get(carousel);
    if (state && state.pause) {
      state.pause();
    }
  };

  const resumeAutoScroll = () => {
    const state = kitBitookuCarouselState.get(carousel);
    if (state && state.syncScrollPos) {
      state.syncScrollPos(viewport.scrollLeft);
    }
    if (state && state.resume) {
      state.resume();
    }
  };

  const onPointerDown = (event) => {
    if (event.button !== 0 && event.pointerType === 'mouse') return;

    isDragging = true;
    startX = event.clientX;
    startScrollLeft = viewport.scrollLeft;
    pauseAutoScroll();
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture(event.pointerId);
  };

  const onPointerMove = (event) => {
    if (!isDragging) return;

    const deltaX = event.clientX - startX;
    viewport.scrollLeft = startScrollLeft - deltaX;

    if (Math.abs(deltaX) > KIT_BITOOKU_DRAG_THRESHOLD && event.pointerType !== 'mouse') {
      event.preventDefault();
    }
  };

  const onPointerEnd = (event) => {
    if (!isDragging) return;

    isDragging = false;
    viewport.classList.remove('is-dragging');

    if (viewport.hasPointerCapture(event.pointerId)) {
      viewport.releasePointerCapture(event.pointerId);
    }

    resumeAutoScroll();
  };

  viewport.addEventListener('pointerdown', onPointerDown);
  viewport.addEventListener('pointermove', onPointerMove);
  viewport.addEventListener('pointerup', onPointerEnd);
  viewport.addEventListener('pointercancel', onPointerEnd);
}

/**
 * 標準キットセット：見切れているときだけゆっくり自動スライド
 */
function stopKitBitookuCarousel(carousel) {
  const state = kitBitookuCarouselState.get(carousel);
  if (!state) return;

  if (state.rafId) {
    cancelAnimationFrame(state.rafId);
  }

  state.clones.forEach((clone) => {
    clone.remove();
  });

  state.viewport.scrollLeft = 0;
  carousel.classList.remove('is-auto-scroll');
  kitBitookuCarouselState.delete(carousel);
}

function startKitBitookuCarousel(carousel) {
  const viewport = carousel.querySelector('.p-kit-bitooku__viewport');
  const list = carousel.querySelector('.p-kit-bitooku__list');
  if (!viewport || !list) return;

  stopKitBitookuCarousel(carousel);

  const originals = [...list.children].filter((item) => !item.classList.contains('p-kit-bitooku__item--clone'));
  const hasOverflow = () => list.scrollWidth > viewport.clientWidth + 2;

  if (!originals.length || !hasOverflow()) {
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    return;
  }

  const originalWidth = list.scrollWidth;
  const clones = originals.map((item) => {
    const clone = item.cloneNode(true);
    clone.classList.add('p-kit-bitooku__item--clone');
    clone.setAttribute('aria-hidden', 'true');
    const cloneFigure = clone.querySelector('.p-kit-bitooku__figure');
    if (cloneFigure) {
      cloneFigure.removeAttribute('tabindex');
      cloneFigure.removeAttribute('role');
      cloneFigure.removeAttribute('aria-label');
    }
    list.appendChild(clone);
    return clone;
  });

  carousel.classList.add('is-auto-scroll');
  viewport.scrollLeft = 0;

  let scrollPos = 0;
  let paused = false;
  const speed = 0.7;

  const animate = () => {
    if (!paused && hasOverflow()) {
      scrollPos += speed;
      if (scrollPos >= originalWidth) {
        scrollPos -= originalWidth;
      }
      viewport.scrollLeft = scrollPos;
    }

    const state = kitBitookuCarouselState.get(carousel);
    if (state) {
      state.rafId = requestAnimationFrame(animate);
    }
  };

  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };

  const syncScrollPos = (left) => {
    let next = left;
    while (next >= originalWidth) {
      next -= originalWidth;
    }
    while (next < 0) {
      next += originalWidth;
    }
    scrollPos = next;
    viewport.scrollLeft = scrollPos;
  };

  kitBitookuCarouselState.set(carousel, {
    viewport,
    list,
    clones,
    rafId: null,
    pause,
    resume,
    syncScrollPos,
  });

  viewport.addEventListener('mouseenter', pause);
  viewport.addEventListener('mouseleave', resume);
  viewport.addEventListener('focusin', pause);
  viewport.addEventListener('focusout', resume);

  animate();
}

function initKitBitookuCarousels() {
  const carousels = document.querySelectorAll('.p-kit-bitooku__carousel');
  if (!carousels.length) return;

  // モーダルとの干渉切り分けのため、ドラッグ/フリック操作は一旦無効化。
  // 自動スクロールはこのまま維持する。

  const refresh = () => {
    carousels.forEach((carousel) => {
      startKitBitookuCarousel(carousel);
    });
  };

  refresh();

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (resizeTimer !== null) {
      window.clearTimeout(resizeTimer);
    }
    resizeTimer = window.setTimeout(refresh, 200);
  });

  window.addEventListener('load', refresh, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
  initKitLinkSelect();
  initKitBitookuModal();
  initKitBitookuCarousels();
});
